<template>
  <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.58203 10.3232L12.3534 13.8527" stroke="#575757" stroke-width="1.41176"></path>
    <!-- eslint-disable-next-line -->
    <path d="M10.9548 6.08847C10.9548 8.82987 8.77694 11.0296 6.11796 11.0296C3.45897 11.0296 1.28108 8.82987 1.28108 6.08847C1.28108 3.34706 3.45897 1.14729 6.11796 1.14729C8.77694 1.14729 10.9548 3.34706 10.9548 6.08847Z" stroke="#575757" stroke-width="1.41176"></path>
  </svg>
</template>
